import React from 'react';
import { useActivityActions } from '../state/ActivityActions';
import { Timeframe } from '../../../components/basic/Timeframe';
import { useActivityTimeframeValues } from '../data/useActivityTimeframe';
import { useDispatcher } from '../../../data/global/hooks';
import { Actions } from '../../../data/global/actions';
import { useBlockId } from '../../../components/blocks/BlockState';

export const TimeframeContainer: React.FC<{ type?: string }> = ({ children, type }) => {
  const { startDate, endDate } = useActivityTimeframeValues();
  const { setTimeframe } = useActivityActions();
  const { dispatch } = useDispatcher();
  const blockId = useBlockId();

  let blockStyle = 'block-section block-section-fixed';

  //if key is present, remove block-section class
  if (type) {
    if (['activityBlockMessage', 'activityBlockTimeFrame'].includes(type)) {
      blockStyle = blockStyle.split(' ')[1].trim();
    }
  }

  return (
    <div style={{ paddingBottom: '10px' }} className={blockStyle}>
      <div className="row">
        <div className="col-auto">
          <Timeframe
            initialStartDate={startDate}
            initialEndDate={endDate}
            onSave={(start, end) => {
              dispatch(Actions.setOrdersRequestPageIndex({ pageIndex: 0, blockId }));
              setTimeframe(start, end);
            }}
            caret={<i className="fal fa-calendar" />}
          />
        </div>
        {children}
      </div>
    </div>
  );
};
